import Price from './styled';

export default Price;
